var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "booking-format-address" },
    [
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ]
        },
        [
          _c(
            "el-checkbox",
            {
              staticStyle: { float: "right" },
              on: {
                change: function($event) {
                  _vm.manifestInfo.consigneeEnterpriseName = _vm.manifestInfo
                    .instructBill
                    ? "TO ORDER"
                    : ""
                }
              },
              model: {
                value: _vm.manifestInfo.instructBill,
                callback: function($$v) {
                  _vm.$set(_vm.manifestInfo, "instructBill", $$v)
                },
                expression: "manifestInfo.instructBill"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.ladingBill")))]
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          attrs: { label: _vm.$t("SeaExport.consigneeCode") }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.consigneeShortCode } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.consigneeShortCode
                  ? "red-border"
                  : "",
                attrs: {
                  placeholder:
                    (_vm.isSeaHouseChannel ||
                      _vm.isWseChannel ||
                      _vm.isRongeTong) &&
                    _vm.isEditing
                      ? _vm.$t("CargoMsg.Cargo_pleaseEnterTheEnterpriseCode")
                      : "",
                  "auto-uppercase": true,
                  "auto-half-word": true
                },
                model: {
                  value: _vm.manifestInfo.consigneeShortCode,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "consigneeShortCode", $$v)
                  },
                  expression: "manifestInfo.consigneeShortCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          staticClass: "label-right",
          attrs: { label: "+" }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.consigneeEnterpriseCode } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.consigneeEnterpriseCode
                  ? "red-border"
                  : "",
                attrs: { "auto-uppercase": true, "auto-half-word": true },
                model: {
                  value: _vm.manifestInfo.consigneeEnterpriseCode,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "consigneeEnterpriseCode", $$v)
                  },
                  expression: "manifestInfo.consigneeEnterpriseCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          ref: "consigneeEnterpriseName",
          class: _vm.labelStyle,
          attrs: {
            label: _vm.$t("SeaExport.consigneeName"),
            prop: "consigneeEnterpriseName",
            rules: [
              {
                validator: _vm.validatorConsigneeEnterpriseName,
                trigger: "blur"
              }
            ]
          }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.consigneeEnterpriseName } },
            [
              !_vm.showCombinedManifest
                ? _c("cargo-input", {
                    class: _vm.importDifferenceField.consigneeEnterpriseName
                      ? "red-border"
                      : "",
                    attrs: {
                      placeholder: _vm.addressTip,
                      "auto-uppercase": true,
                      "auto-half-word": true,
                      trim:
                        _vm.isSeaHouseChannel ||
                        _vm.isWseChannel ||
                        _vm.isRongeTong
                    },
                    model: {
                      value: _vm.manifestInfo.consigneeEnterpriseName,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.manifestInfo,
                          "consigneeEnterpriseName",
                          $$v
                        )
                      },
                      expression: "manifestInfo.consigneeEnterpriseName"
                    }
                  })
                : _c("cargo-rich-textarea", {
                    class: _vm.importDifferenceField.consigneeEnterpriseName
                      ? "red-border"
                      : "",
                    staticStyle: {
                      height: "70px",
                      "min-height": "70px",
                      width: "180px"
                    },
                    attrs: {
                      no: "consigneeEnterpriseName",
                      "text-chars": 0,
                      "warning-count": -1,
                      "wrap-symbol": "n",
                      "auto-half-word": "",
                      "auto-uppercase": "",
                      disabled: !_vm.isEditing,
                      "is-trim":
                        _vm.isSeaHouseChannel ||
                        _vm.isWseChannel ||
                        _vm.isRongeTong
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.consigneeName"),
                          _vm.manifestInfo.consigneeEnterpriseName,
                          function(val) {
                            _vm.manifestInfo.consigneeEnterpriseName = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.manifestInfo.consigneeEnterpriseName,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.manifestInfo,
                          "consigneeEnterpriseName",
                          $$v
                        )
                      },
                      expression: "manifestInfo.consigneeEnterpriseName"
                    }
                  })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          ref: "consigneeAddress",
          class: _vm.labelStyle,
          attrs: {
            label: _vm.$t("SeaExport.consigneeDetailAddress"),
            prop: "consigneeAddress",
            rules: [
              { validator: _vm.validatorConsigneeAddress, trigger: "blur" }
            ]
          }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.consigneeAddress } },
            [
              !_vm.showCombinedManifest
                ? _c("cargo-input", {
                    class: _vm.importDifferenceField.consigneeAddress
                      ? "red-border"
                      : "",
                    attrs: {
                      placeholder: _vm.addressTip2,
                      "auto-uppercase": true,
                      "auto-half-word": true,
                      trim:
                        _vm.isSeaHouseChannel ||
                        _vm.isWseChannel ||
                        _vm.isRongeTong
                    },
                    model: {
                      value: _vm.manifestInfo.consigneeAddress,
                      callback: function($$v) {
                        _vm.$set(_vm.manifestInfo, "consigneeAddress", $$v)
                      },
                      expression: "manifestInfo.consigneeAddress"
                    }
                  })
                : _c("cargo-rich-textarea", {
                    ref: "cargoTextarea1",
                    class: _vm.importDifferenceField.consigneeAddress
                      ? "red-border"
                      : "",
                    staticStyle: { height: "110px", width: "180px" },
                    attrs: {
                      no: "consigneeAddress",
                      "text-chars": 0,
                      "warning-count": -1,
                      "wrap-symbol": "n",
                      "auto-half-word": "",
                      "auto-uppercase": "",
                      disabled: !_vm.isEditing,
                      "is-trim":
                        _vm.isSeaHouseChannel ||
                        _vm.isWseChannel ||
                        _vm.isRongeTong
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.consigneeDetailAddress"),
                          _vm.manifestInfo.consigneeAddress,
                          function(val) {
                            _vm.manifestInfo.consigneeAddress = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.manifestInfo.consigneeAddress,
                      callback: function($$v) {
                        _vm.$set(_vm.manifestInfo, "consigneeAddress", $$v)
                      },
                      expression: "manifestInfo.consigneeAddress"
                    }
                  })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "auto-width",
          class:
            _vm.manifestInfo.consigneeContactsType === 0
              ? _vm.labelStyle
              : "mag",
          staticStyle: { display: "inline-block" },
          attrs: { "label-width": "0" }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "el-select",
                {
                  class: _vm.importDifferenceField.consigneeContactsType
                    ? "require-select red-border"
                    : "require-select",
                  staticStyle: { width: "146px" },
                  on: { change: _vm.changeContactsType },
                  model: {
                    value: _vm.manifestInfo.consigneeContactsType,
                    callback: function($$v) {
                      _vm.$set(_vm.manifestInfo, "consigneeContactsType", $$v)
                    },
                    expression: "manifestInfo.consigneeContactsType"
                  }
                },
                [
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.consigneePhone"),
                      value: 0
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.consigneeEmail"),
                      value: 1
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.consigneeRelexNumber"),
                      value: 2
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-form-item",
        {
          ref: "consignorPhone",
          staticClass: "auto-width",
          class:
            _vm.manifestInfo.consigneeContactsType === 0
              ? _vm.labelStyle
              : "mag",
          staticStyle: { display: "inline-block" },
          attrs: {
            "label-width": "0",
            prop: "consignorPhone",
            rules: [{ validator: _vm.validatorConsignorPhone, trigger: "blur" }]
          }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.consigneeContacts } },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content:
                      _vm.manifestInfo.consigneeContactsType === 0
                        ? _vm.$t("CargoMsg.Cargo_pleaseEnterAPhoneNumber")
                        : "",
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-input", {
                    class: _vm.importDifferenceField.consigneeContacts
                      ? "red-border"
                      : "",
                    staticStyle: { width: "174px", "margin-left": "4px" },
                    attrs: {
                      "auto-uppercase": true,
                      "auto-half-word": true,
                      placeholder:
                        _vm.manifestInfo.consigneeContactsType === 0 &&
                        (_vm.isSeaHouseChannel ||
                          _vm.isWseChannel ||
                          _vm.isRongeTong) &&
                        _vm.isEditing
                          ? _vm.$t("CargoMsg.Cargo_pleaseEnterAPhoneNumber")
                          : ""
                    },
                    model: {
                      value: _vm.manifestInfo.consigneeContacts,
                      callback: function($$v) {
                        _vm.$set(_vm.manifestInfo, "consigneeContacts", $$v)
                      },
                      expression: "manifestInfo.consigneeContacts"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          attrs: { label: _vm.$t("SeaExport.cityName") }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.consigneeCityName } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.consigneeCityName
                  ? "red-border"
                  : "",
                attrs: { "auto-uppercase": true, "auto-half-word": true },
                model: {
                  value: _vm.manifestInfo.consigneeCityName,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "consigneeCityName", $$v)
                  },
                  expression: "manifestInfo.consigneeCityName"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          attrs: { label: _vm.$t("SeaExport.provinceCode") }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.consigneeProvinceCode } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.consigneeProvinceCode
                  ? "red-border"
                  : "",
                attrs: { "auto-uppercase": true, "auto-half-word": true },
                model: {
                  value: _vm.manifestInfo.consigneeProvinceCode,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "consigneeProvinceCode", $$v)
                  },
                  expression: "manifestInfo.consigneeProvinceCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          attrs: { label: _vm.$t("SeaExport.provinceName") }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.consigneeProvinceName } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.consigneeProvinceName
                  ? "red-border"
                  : "",
                attrs: { "auto-uppercase": true, "auto-half-word": true },
                model: {
                  value: _vm.manifestInfo.consigneeProvinceName,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "consigneeProvinceName", $$v)
                  },
                  expression: "manifestInfo.consigneeProvinceName"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          attrs: { label: _vm.$t("SeaExport.ZipCode") }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.consigneeZipCode } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.consigneeZipCode
                  ? "red-border"
                  : "",
                attrs: { "auto-uppercase": true, "auto-half-word": true },
                model: {
                  value: _vm.manifestInfo.consigneeZipCode,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "consigneeZipCode", $$v)
                  },
                  expression: "manifestInfo.consigneeZipCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          ref: "consigneeCountryCode",
          class: _vm.labelStyle,
          attrs: {
            label: _vm.$t("CargoMsg.Cargo_CountryRegionCode"),
            prop: "consigneeCountryCode",
            rules: [
              {
                validator: _vm.validatorConsigneeCountryCode,
                trigger: "change"
              }
            ]
          }
        },
        [
          _c(
            "el-tooltip",
            {
              attrs: {
                content: _vm.$t("CargoMsg.Cargo_pleaseSelectACountryCode"),
                placement: "bottom",
                effect: "light"
              }
            },
            [
              _c(
                "special-character-tip",
                { attrs: { texts: _vm.specialCharCheck.consigneeCountryCode } },
                [
                  !_vm.isSeaHouseChannel &&
                  !_vm.isWseChannel &&
                  !_vm.isRongeTong
                    ? _c("cargo-input", {
                        class: _vm.importDifferenceField.consigneeCountryCode
                          ? "red-border"
                          : "",
                        attrs: {
                          "auto-uppercase": true,
                          "auto-half-word": true
                        },
                        model: {
                          value: _vm.manifestInfo.consigneeCountryCode,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.manifestInfo,
                              "consigneeCountryCode",
                              $$v
                            )
                          },
                          expression: "manifestInfo.consigneeCountryCode"
                        }
                      })
                    : _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.consigneeCountryCode
                          ? "red-border"
                          : "",
                        attrs: {
                          "static-options": _vm.countryList || [],
                          cache: false,
                          "default-value":
                            _vm.manifestInfo.consigneeCountryCode,
                          filterable: "",
                          clearable: "",
                          "filter-tag-names": ["name", "code", "chineseName"],
                          "tag-name": "name",
                          "custom-label": function(item) {
                            return "[" + item.code + "]" + item.name
                          },
                          "tag-value": "code",
                          placeholder: _vm.$t(
                            "CargoMsg.Cargo_pleaseSelectACountryCode"
                          )
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.manifestInfo.consigneeCountryCode = p.value
                          }
                        }
                      })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          attrs: { label: _vm.$t("SeaExport.aeoEnterpriseCode") }
        },
        [
          _c(
            "special-character-tip",
            {
              attrs: { texts: _vm.specialCharCheck.consigneeAeoEnterpriseCode }
            },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.consigneeAeoEnterpriseCode
                  ? "red-border"
                  : "",
                attrs: { "auto-uppercase": true, "auto-half-word": true },
                model: {
                  value: _vm.manifestInfo.consigneeAeoEnterpriseCode,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.manifestInfo,
                      "consigneeAeoEnterpriseCode",
                      $$v
                    )
                  },
                  expression: "manifestInfo.consigneeAeoEnterpriseCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          attrs: { label: _vm.$t("SeaExport.specificContactName") }
        },
        [
          _c(
            "special-character-tip",
            {
              attrs: {
                texts: _vm.specialCharCheck.consigneeSpecificContactsName
              }
            },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.consigneeSpecificContactsName
                  ? "red-border"
                  : "",
                attrs: {
                  placeholder:
                    (_vm.isSeaHouseChannel ||
                      _vm.isWseChannel ||
                      _vm.isRongeTong) &&
                    _vm.isEditing
                      ? _vm.$t("CargoMsg.Cargo_pleaseEnterTheActualContactName")
                      : "",
                  "auto-uppercase": true,
                  "auto-half-word": true
                },
                model: {
                  value: _vm.manifestInfo.consigneeSpecificContactsName,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.manifestInfo,
                      "consigneeSpecificContactsName",
                      $$v
                    )
                  },
                  expression: "manifestInfo.consigneeSpecificContactsName"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          staticClass: "auto-width",
          attrs: { "label-width": "0" }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "el-select",
                {
                  class: _vm.importDifferenceField.consigneeSpecificContactsType
                    ? "red-border"
                    : "",
                  staticStyle: { width: "146px" },
                  model: {
                    value: _vm.manifestInfo.consigneeSpecificContactsType,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.manifestInfo,
                        "consigneeSpecificContactsType",
                        $$v
                      )
                    },
                    expression: "manifestInfo.consigneeSpecificContactsType"
                  }
                },
                [
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.specificContactPhone"),
                      value: 0
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.specificContactAddress"),
                      value: 1
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.specificContactRelexNumber"),
                      value: 2
                    }
                  })
                ],
                1
              ),
              _c(
                "special-character-tip",
                {
                  attrs: {
                    texts: _vm.specialCharCheck.consigneeSpecificContacts
                  }
                },
                [
                  _c("cargo-input", {
                    class: _vm.importDifferenceField.consigneeSpecificContacts
                      ? "red-border"
                      : "",
                    staticStyle: { width: "174px", "margin-left": "4px" },
                    attrs: {
                      "auto-uppercase": true,
                      "auto-half-word": true,
                      placeholder:
                        _vm.manifestInfo.consigneeSpecificContactsType === 0 &&
                        (_vm.isSeaHouseChannel ||
                          _vm.isWseChannel ||
                          _vm.isRongeTong) &&
                        _vm.isEditing
                          ? _vm.$t("CargoMsg.Cargo_pleaseEnterAPhoneNumber")
                          : ""
                    },
                    model: {
                      value: _vm.manifestInfo.consigneeSpecificContacts,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.manifestInfo,
                          "consigneeSpecificContacts",
                          $$v
                        )
                      },
                      expression: "manifestInfo.consigneeSpecificContacts"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "center",
            "align-items": "center"
          }
        },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.notSeaHouseChannelOrWseChannel,
                  expression: "!notSeaHouseChannelOrWseChannel"
                }
              ],
              staticStyle: { "margin-left": "5px", height: "28px" },
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.copyNotifier()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CopyNotifier")))]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceTextDialog",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            },
            close: _vm.closeAdvanceText
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              no: "advanceTextDialogTextarea",
              disabled: !_vm.isEditing,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c("span", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isEditing,
                    expression: "isEditing"
                  }
                ],
                staticClass: "el-button el-button--default el-button--mini",
                attrs: { no: "advanceTextDialogConfirm", type: "button" },
                on: { click: _vm.finishAdvanceText }
              },
              [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
            ),
            _c(
              "button",
              {
                staticClass: "el-button el-button--default el-button--mini",
                attrs: { no: "advanceTextDialogClose", type: "button" },
                on: {
                  click: function($event) {
                    _vm.advanceTextDialog.visible = false
                    _vm.closeAdvanceText()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }